import { makeStyles, Tooltip, Typography } from "@material-ui/core";
import { Check } from "@material-ui/icons";
import React from "react";
import { useRecordContext, useTranslate } from "react-admin";

import { OfficeField } from "../offices/OfficeField";
import { useSeason } from "../../common/inputs/SeasonSelector";

const useStyles = makeStyles((theme) => ({
  list: {
    margin: 0,
    paddingLeft: theme.spacing(1.5),
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
  }
}));

export const AffiliationLabel = () => {
  const seasonId = useSeason();
  const translate = useTranslate();
  const classes = useStyles();
  return <div className={classes.stack}>
    <Typography variant="inherit">{translate('resources.participantMemberTypes.labels.affiliated')}</Typography>
    <Typography variant="body2" color="textSecondary">{`${translate('ra.action.active')} - ${seasonId}`}</Typography>
  </div>
}

export const AffiliationField = ({ source, memberTypes = [], ...props }) => {
  const classes = useStyles();
  const record = useRecordContext();
  const participantId = record[source];

  const affiliations = memberTypes.filter(memberType => memberType.participantId === participantId);

  if (!affiliations?.length) return null;
  return <Tooltip
    title={
      <ul className={classes.list}>
        {affiliations.map((affiliation, index) => (
          <li key={affiliation.id}>
            <OfficeField record={affiliation} source="officeId" />
          </li>
        ))}
      </ul>
    }
  >
    <Check fontSize="small" />
  </Tooltip>
};
